import { PiCategoryEnum } from '@utmb/types/enum/PiCategoryEnum';
import { WorldSeriesCategoryEnum } from '@utmb/types/enum/WorldSeriesCategoryEnum';

export const getRaceCategoryColor = (cat: PiCategoryEnum | WorldSeriesCategoryEnum, isVarCss = true): string => {
    const RaceCategoryColor: {
        [K in WorldSeriesCategoryEnum | PiCategoryEnum]: string;
    } = {
        ws100M: isVarCss ? '--utmb-color-category-100m' : '#f42525',

        '100m': isVarCss ? '--utmb-color-category-100m' : '#f42525',

        ws100KM: isVarCss ? '--utmb-color-category-100k' : '#7ddf65',

        '100k': isVarCss ? '--utmb-color-category-100k' : '#7ddf65',

        ws50KM: isVarCss ? '--utmb-color-category-50k' : '#fc5a00',

        '50k': isVarCss ? '--utmb-color-category-50k' : '#fc5a00',

        ws20KM: isVarCss ? `--utmb-color-category-20k` : '#ffff00',

        '20k': isVarCss ? `--utmb-color-category-20k` : '#ffff00',

        general: isVarCss ? '--utmb-color-ws-primary' : '#00dbff',
    };

    return RaceCategoryColor[cat];
};
